import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from 'app/core/auth/session.service';
import { filter, map, take } from 'rxjs';

/**
 * Restringe una rama de rutas a ciertas empresas (context.company.id).
 * Espera a que la sesión deje de estar 'initializing' (recarga de página);
 * si la empresa no está permitida, redirige al Tablero de Control.
 *
 *   { path: 'nwk', canActivate: [empresaGuard([164])], children: [...] }
 */
export const empresaGuard = (empresas: number[]): CanActivateFn => () => {
    const router = inject(Router);
    return inject(SessionService).state$.pipe(
        filter((state) => state.status !== 'initializing'),
        take(1),
        map((state) => {
            const kemp = Number(state.context?.company?.id ?? 0);
            return empresas.includes(kemp) ? true : router.parseUrl('/ger/dbg');
        }),
    );
};
